import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-light-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

const renderNumberCircleComponent = (params: {
  isActive: boolean,
  isComplete: boolean,
  stepNumber: number,
}) => {
  const {
    isActive, isComplete, stepNumber,
  } = params

  if (isActive){
    return (
      <Box
        alignItems="center"
        backgroundColor="blue"
        border="1px solid"
        borderColor="blue"
        borderRadius="100%"
        color="white"
        fontSize="small"
        height={26}
        justifyContent="center"
        width={26}
      >
        {stepNumber}
      </Box>
    )
  }

  if (isComplete){
    return (
      <Box
        alignItems="center"
        border="1px solid"
        borderColor="lineColor"
        borderRadius="100%"
        color="blue"
        fontSize="small"
        height={26}
        justifyContent="center"
        width={26}
      >
        <FontAwesomeIcon icon={faCheck} />
      </Box>
    )
  }

  return (
    <Box
      alignItems="center"
      border="1px solid"
      borderColor="lineColor"
      borderRadius="100%"
      color="lightGrey"
      fontSize="small"
      height={26}
      justifyContent="center"
      width={26}
    >
      {stepNumber}
    </Box>
  )
}

interface NavigationItemProps {
  body?: string,
  callbacks?: {
    onClick: () => void,
  },
  isActive?: boolean,
  isComplete?: boolean,
  isFirst?: boolean,
  isLast?: boolean,
  label: string,
  stepNumber: number,
}

const NavigationItem = (props: NavigationItemProps) => {
  const {
    body,
    callbacks,
    isActive = false,
    isComplete = false,
    isFirst = false,
    isLast = false,
    label,
    stepNumber,
  } = props

  const { onClick } = callbacks || {}

  const isIncomplete = !isComplete && !isActive

  return (
    <Box
      borderColor="lineColor"
      onClick={onClick}
      position="relative"
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <Box
        alignItems="center"
        flexDirection="column"
        flexShrink={0}
        height="100%"
        justifyContent="center"
        marginLeft="large"
        width="26px"
      >
        <Box backgroundColor={isFirst ? null : 'whiteGrey'} height="calc((100% - 26px) / 2)" width={2} />

        {renderNumberCircleComponent({
          isActive,
          isComplete,
          stepNumber,
        })}

        <Box backgroundColor={isLast ? null : 'whiteGrey'} height="calc((100% - 26px) / 2)" width={2} />
      </Box>

      <Box flexDirection="column" marginLeft="large" paddingY="large" width="auto">
        <Text color={isIncomplete ? 'lightGrey' : 'bodyFontLightColor'} fontSize="xsmall">
          {label}
        </Text>
        <Text color={isIncomplete ? 'lightGrey' : 'bodyFontColor'} fontSize="small" marginTop="small">
          {body}
        </Text>
      </Box>
    </Box>
  )
}

export default NavigationItem
